import { FC } from "react";

import { FormLocation, FormLocationProps } from "@/forms-design-system/FormLocation";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedAuctionFormLocationProps = Omit<FormLocationProps, "title" | "subtitle"> & {
  address: string;
  latitude?: number;
  longitude?: number;
};

export const ThemedAuctionFormLocation: FC<ThemedAuctionFormLocationProps> = ({
  latitude,
  longitude,
  address,
  ...rest
}) => {
  const { t } = useTranslate();

  const googleMapsLink = latitude && longitude ? `https://www.google.com/maps?q=${latitude},${longitude}` : undefined;

  return (
    <FormLocation
      id="ticketing-address-summary"
      data-test="ticketing-address-summary"
      title={t("ticketing", "auction.pickupLocation")}
      href={googleMapsLink}
      target="_blank"
      rel="noopener noreferrer"
      subtitle={address}
      components={{
        title: {
          sx: {
            textDecoration: "none !important", // Remove the underline for the title, since it's a regular label
          },
        },
        ...rest.components,
      }}
      {...rest}
    />
  );
};
